import React, {CSSProperties, ReactNode} from "react"
import classNames from "classnames"

import Styles from "./text.less"

type TextProps = {
    type: "answer" | "input"
    content: string | ReactNode
    style?: CSSProperties
    isFullScreen?: boolean
    onMouseEnter: () => void
    onMouseLeave: () => void
}

const Text: React.FC<TextProps> = (props) => {
    const {type, content, style, isFullScreen} = props

    const classes = classNames(Styles[type], Styles["text"])

    const ownStyle = {
        ...style,
        maxWidth: isFullScreen ? 400 : 270,
    }

    return (
        <div className={classes} onMouseLeave={props.onMouseLeave} onMouseEnter={props.onMouseEnter} style={ownStyle}>
            {content}
        </div>
    )
}

export default Text
